// extracted by mini-css-extract-plugin
export default {"chip":"style_chip__ph+l-"};